import React from "react";
import { Phone } from "lucide-react";
import { LangToggle } from "./LangToggle";

export const MobileMenu = ({ t, lang, setLang, navLinks, onNavigate }) => (
  <div data-testid="mobile-menu" className="lg:hidden bg-white border-t border-brand px-5 py-5 space-y-1">
    {navLinks.map((l) => (
      <a
        key={l.id}
        href={l.href}
        onClick={onNavigate}
        data-testid={`mobile-nav-${l.id}`}
        className="block py-2.5 font-display font-semibold text-brand-primary border-b border-brand last:border-0"
      >
        {l.label}
      </a>
    ))}
    <LangToggle lang={lang} setLang={setLang} variant="wide" testIdPrefix="mobile-lang" />
    <a href={`tel:${t.phone.tel}`} data-testid="mobile-call-cta" className="btn-primary w-full mt-3 text-sm">
      <Phone className="w-4 h-4" strokeWidth={2.5} />
      {t.phone.display}
    </a>
  </div>
);
